import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../redux/hooks';
import Unauthorised from "./Unauthorised";

interface PrivateRouteProps {
  element?: React.ReactNode;
  roles?: string[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ element, roles }) => {
  const user = useAppSelector(state => state.auth.user);
  const location = useLocation();

  if (!user) {
    // Not logged in, redirect to login page
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (roles && roles.length > 0 && !roles.some(role => user.roles && user.roles.includes(role))) {
    // User doesn't have required role, show unauthorized message
    return <Unauthorised />;
  }

  // User has required role, render the element or outlet
  return element ? <>{element}</> : <Outlet />;
};

export default PrivateRoute;
